export const researchQuizTranslations = {
  en: {
    quizUnavailableTitle: "This page is not available",
    quizUnavailableBody: "This research page is currently disabled.",

    quizConsentTitle: "Quick research check — 2 minutes",
    quizConsentBody:
      "We're checking whether the homepage recommendation is easy to understand. You'll see three example screens and answer a few short questions. We do not ask for your name, email, or any identifying information. Your answers are saved to a private research spreadsheet. Please don't enter any personal information in the optional comment field.",
    quizConsentContinue: "Start",
    quizConsentDecline: "No thanks",

    quizStepLabel: "Screen {current} of {total}",
    quizQuestionInterpretation: "What does this page recommend?",
    quizQuestionReason: "What is the main reason?",
    quizQuestionAction: "What would you do next?",
    quizQuestionNote: "Anything that was unclear? (optional)",
    quizNext: "Next",
    quizSubmit: "Send results",

    quizInterpretationStay: "Stay where you are",
    quizInterpretationMove: "Move to a different site",
    quizInterpretationConsider: "A different site might be worth considering",
    quizInterpretationUnsure: "Not sure",

    quizReasonWeatherBetterElsewhere: "Weather looks better elsewhere",
    quizReasonWeatherSimilar: "Weather looks about the same everywhere",
    quizReasonWeatherWorseElsewhere: "Weather looks worse elsewhere",
    quizReasonNotSureWhy: "Not sure why",
    quizReasonOther: "Other",

    quizActionStayPut: "Stay at the current site",
    quizActionRelocateNow: "Start looking at other sites now",
    quizActionKeepMonitoring: "Keep an eye on the forecast",
    quizActionNotSure: "Not sure",
    quizActionOther: "Other",

    quizSubmittingLabel: "Sending…",
    quizConfirmedTitle: "Thank you!",
    quizConfirmedBody: "Your answers were saved. You can close this page now.",
    quizFailedTitle: "Something went wrong",
    quizFailedBody: "Your answers were not saved. Please try again.",
    quizUnconfirmedTitle: "We couldn't confirm this was saved",
    quizUnconfirmedBody: "Your answers may not have been saved. It's safe to try again — nothing will be duplicated.",
    quizRetry: "Try again",
  },
  is: {
    quizUnavailableTitle: "Þessi síða er ekki tiltæk",
    quizUnavailableBody: "Þessi rannsóknarsíða er óvirk eins og er.",

    quizConsentTitle: "Stutt rannsóknarkönnun — 2 mínútur",
    quizConsentBody:
      "Við erum að kanna hvort ráðleggingin á forsíðunni sé auðskiljanleg. Þú sérð þrjú dæmi og svarar nokkrum stuttum spurningum. Við biðjum ekki um nafn, netfang eða aðrar persónugreinanlegar upplýsingar. Svörin vistast í einkareikniblaði rannsakanda. Vinsamlegast ekki setja persónuupplýsingar í valfrjálsa athugasemdareitinn.",
    quizConsentContinue: "Byrja",
    quizConsentDecline: "Nei takk",

    quizStepLabel: "Skjár {current} af {total}",
    quizQuestionInterpretation: "Hvað mælir þessi síða með?",
    quizQuestionReason: "Hver er helsta ástæðan?",
    quizQuestionAction: "Hvað myndir þú gera næst?",
    quizQuestionNote: "Var eitthvað óskýrt? (valfrjálst)",
    quizNext: "Áfram",
    quizSubmit: "Senda niðurstöður",

    quizInterpretationStay: "Vera áfram á núverandi stað",
    quizInterpretationMove: "Færa sig á annan stað",
    quizInterpretationConsider: "Annar staður gæti verið þess virði að skoða",
    quizInterpretationUnsure: "Ekki viss",

    quizReasonWeatherBetterElsewhere: "Veðrið lítur betur út annars staðar",
    quizReasonWeatherSimilar: "Veðrið er svipað alls staðar",
    quizReasonWeatherWorseElsewhere: "Veðrið lítur verr út annars staðar",
    quizReasonNotSureWhy: "Ekki viss af hverju",
    quizReasonOther: "Annað",

    quizActionStayPut: "Vera áfram á núverandi tjaldsvæði",
    quizActionRelocateNow: "Byrja að skoða aðra staði núna",
    quizActionKeepMonitoring: "Fylgjast með spánni áfram",
    quizActionNotSure: "Ekki viss",
    quizActionOther: "Annað",

    quizSubmittingLabel: "Sendi…",
    quizConfirmedTitle: "Takk fyrir!",
    quizConfirmedBody: "Svörin þín voru vistuð. Þú getur lokað þessari síðu núna.",
    quizFailedTitle: "Eitthvað fór úrskeiðis",
    quizFailedBody: "Svörin þín vistuðust ekki. Vinsamlegast reyndu aftur.",
    quizUnconfirmedTitle: "Við gátum ekki staðfest að þetta hafi vistast",
    quizUnconfirmedBody: "Svörin þín gætu ekki hafa vistast. Það er óhætt að reyna aftur — ekkert tvítekst.",
    quizRetry: "Reyna aftur",
  },
};
